import { render, staticRenderFns } from "./PlatformSchedulingSQL.vue?vue&type=template&id=36044e63&scoped=true&"
import script from "./PlatformSchedulingSQL.vue?vue&type=script&lang=js&"
export * from "./PlatformSchedulingSQL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36044e63",
  null
  
)

export default component.exports